import InfiniteScroll from "react-infinite-scroll-component"
import { Container, Row, Col, Card } from "react-bootstrap"
import "react-dropdown-tree-select/dist/styles.css"
import React, { useEffect, useState } from "react"
import { SERVER_IP, ud, jwt } from "../../Server"
import "bootstrap/dist/css/bootstrap.min.css"
import { saveAs } from "file-saver"
import "../../assets/css/style.css"
import "../../assets/css/icons.css"
import swal from "sweetalert"
import axios from "axios"
import Loader from "../Components/Loader"

export default function VideoCallStatictics() {
  const [calllog, setCalllog] = useState([])
  const [loading, setLoading] = useState(false)
  const [totalResult, setTotalResult] = useState(0)
  const [page, setPage] = useState(0)

  const fetchCallLog = () => {
    const url = `${SERVER_IP}/video/chat/room`
    const headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString()
    }
    var data = { user_id: 143, page }
    setLoading(true)
    axios.post(url, data, { withCredentials: true,  headers: headers }).then((response) => {
      setLoading(false)
      if (response.data.error === false) {
        setTotalResult(response.data.total_count)
        setCalllog(response.data.results || [])
      }
    }).catch((error) => {
      setLoading(false)
      console.log(error)
      swal("Something Went Wrong, Please Retry")
    })
  }

  const fetchMoreData = () => {
    const url = `${SERVER_IP}/video/chat/room`
    const headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString()
    }
    var data = { user_id: 143, page: page + 1 }
    setPage(page + 1)
    axios.post(url, data, { withCredentials: true,  headers: headers }).then((response) => {
      if (response.data.error === false) {
        setTotalResult(response.data.total_count)
        setCalllog(calllog.concat(response.data.results))
      } 
    }).catch((error) => {
      console.log(error)
      swal("Something Went Wrong, Please Retry")
    })
  }

  const downloadFile = (file_url, file_name) => saveAs(file_url, file_name)

  useEffect(() => fetchCallLog(), [])

  return (
    <>
      <div className="xp-breadcrumbbar">
        <div className="row">
          <div className="col-md-6 col-lg-6">
            <h3 className="xp-page-title">Video Call logs</h3>
          </div>
          <div className="col-md-12 col-lg-12">
            <div className="xp-breadcrumb gradient-border">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a onClick={() => (window.location.href = "/dashboard")}>
                    <i className="icon-home"></i>
                  </a>
                </li>
                <li className="breadcrumb-item active">Video Call logs</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="xp-contentbar p-30">
        <div className="row">
          <div className="col-lg-12">
            <div className="card m-b-30 document_gradient_border padding-0">
              <div className="card-header border-radius-top-15">
                <h5 className="card-title">Video Call Logs</h5>
              </div>
              
              {calllog.length > 0 ?
              <div className="card-body">
                {loading && <Loader />}
                <InfiniteScroll dataLength={calllog.length} next={fetchMoreData} hasMore={calllog.length !== totalResult} loader={<Loader />} >
                  <Container className="p-2">
                    {calllog.map((element, index) => {
                      return (
                        <Row className="mt-2" key={index}>
                          <Col xs={2}>{new Date(element.start_datetime).toLocaleString()}</Col>
                          <Col xs={9}>
                            <Card className="text-center">
                              <Card.Header>Room ID: {element.room_id}</Card.Header>
                              <Card.Body style={{ minHeight: "120px", maxHeight: "520px" }}>
                                {element.message.map((element, index) => {
                                  return (
                                    <>
                                          {ud.id == element.from_user_id ? (
                                            element.nonremovable == true ? (
                                              // Invite, Joined And Left Message
                                              <div
                                                className="outgoing_msg"
                                                key={index}
                                              >
                                                <div
                                                  className="sent_msg"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        backgroundColor:
                                                          "rgb(194, 194, 194, 1)",
                                                      }}
                                                    >
                                                      {element.message}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : element.delete_msg == true ? (
                                              // Delete: This message was deleted
                                              <div
                                                className="outgoing_msg"
                                                key={index}
                                              >
                                                <div
                                                  className="sent_msg"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-end",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "flex-end",
                                                    }}
                                                  >
                                                    <span className="name">
                                                      {element.from_name}
                                                    </span>
                                                    <span className="date">
                                                      {
                                                        element.datetime?.split(
                                                          " "
                                                        )[0]
                                                      }
                                                    </span>
                                                    <p
                                                      style={{
                                                        backgroundColor:
                                                          "rgb(185, 49, 47)",
                                                      }}
                                                    >
                                                      This message was deleted
                                                    </p>
                                                    <span className="time">
                                                      {
                                                        element.datetime?.split(
                                                          " "
                                                        )[1]
                                                      }{" "}
                                                      {
                                                        element.datetime?.split(
                                                          " "
                                                        )[2]
                                                      }
                                                    </span>
                                                  </div>
                                                  <div
                                                    style={{
                                                      width: "30px",
                                                      height: "96px",
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      justifyContent:
                                                        "space-between",
                                                      alignItems: "flex-end",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    <div className="incoming_msg_img">
                                                      <img
                                                        style={{
                                                          borderRadius: "50%",
                                                        }}
                                                        src={`${SERVER_IP}/icons/${element.from_icon}`}
                                                        alt="img"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : // Outgoing
                                            element.message_type == "IMAGE" ||
                                              element.message_type == "VIDEO" ||
                                              element.message_type == "AUDIO" ||
                                              element.message_type == "FILE" ? (
                                              <div
                                                className="outgoing_msg"
                                                key={index}
                                              >
                                                {element.file
                                                  ?.split(
                                                    "https://milan1.azurewebsites.net/"
                                                  )[1]
                                                  ?.split(".")[1] == "png" ||
                                                element.file
                                                  ?.split(
                                                    "https://milan1.azurewebsites.net/"
                                                  )[1]
                                                  ?.split(".")[1] == "jpg" ? (
                                                  <div
                                                    className="sent_msg"
                                                    style={{ display: "flex" }}
                                                  >
                                                    <div className="sent_withd_msg">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "flex-end",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "flex-end",
                                                          }}
                                                        >
                                                          <span className="name">
                                                            {element.from_name}
                                                          </span>
                                                          <span className="date">
                                                            {
                                                              element.datetime?.split(
                                                                " "
                                                              )[0]
                                                            }
                                                          </span>
                                                          <div className="sent_file_msg">
                                                            <div className="received_file_div">
                                                              <img
                                                                style={{
                                                                  borderRadius:
                                                                    "50%",
                                                                }}
                                                                src={element.file}
                                                                alt="Uploaded Image"
                                                              />
                                                              <div className="received_file_txt">
                                                                <p>
                                                                  {
                                                                    element.file_name
                                                                  }
                                                                </p>
                                                              </div>
                                                            </div>
                                                            <button
                                                              type="button"
                                                              className="btn btn-outline-light w-100"
                                                              onClick={() =>
                                                                downloadFile(
                                                                  element.file,
                                                                  element.file_name
                                                                )
                                                              }
                                                            >
                                                              <i className="fa-solid fa-download"></i>
                                                            </button>
                                                          </div>
                                                          <span className="time">
                                                            {
                                                              element.datetime?.split(
                                                                " "
                                                              )[1]
                                                            }{" "}
                                                            {
                                                              element.datetime?.split(
                                                                " "
                                                              )[2]
                                                            }
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      style={{
                                                        width: "30px",
                                                        height: "180px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "flex-end",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <div className="incoming_msg_img">
                                                        <img
                                                          style={{
                                                            borderRadius: "50%",
                                                          }}
                                                          src={`${SERVER_IP}/icons/${element.from_icon}`}
                                                          alt="img"
                                                        />
                                                      </div>
                                                      <i
                                                        className="fa-solid fa-check-double"
                                                        style={{
                                                          marginBottom: "5px",
                                                          marginLeft: "10px",
                                                          color: "green",
                                                        }}
                                                      ></i>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div
                                                    className="sent_msg"
                                                    style={{ display: "flex" }}
                                                    key={index}
                                                  >
                                                    <div className="sent_withd_msg">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "flex-end",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "flex-end",
                                                          }}
                                                        >
                                                          <span className="name">
                                                            {element.from_name}
                                                          </span>
                                                          <span className="date">
                                                            {
                                                              element.datetime?.split(
                                                                " "
                                                              )[0]
                                                            }
                                                          </span>
                                                          <div className="sent_file_msg">
                                                            <div className="received_file_div">
                                                              <img
                                                                src="https://www.pngall.com/wp-content/uploads/2018/05/Files-High-Quality-PNG.png"
                                                                alt=""
                                                              />
                                                              <div className="received_file_txt">
                                                                <p>
                                                                  {
                                                                    element.file_name
                                                                  }
                                                                </p>
                                                              </div>
                                                            </div>
                                                            <button
                                                              type="button"
                                                              className="btn btn-outline-light w-100"
                                                              onClick={() =>
                                                                downloadFile(
                                                                  element.file,
                                                                  element.file_name
                                                                )
                                                              }
                                                            >
                                                              <i className="fa-solid fa-download"></i>
                                                            </button>
                                                          </div>
                                                          <span className="time">
                                                            {
                                                              element.datetime?.split(
                                                                " "
                                                              )[1]
                                                            }{" "}
                                                            {
                                                              element.datetime?.split(
                                                                " "
                                                              )[2]
                                                            }
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div
                                                      style={{
                                                        width: "30px",
                                                        height: "180px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent:
                                                          "space-between",
                                                        alignItems: "flex-end",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <div className="incoming_msg_img">
                                                        <img
                                                          style={{
                                                            borderRadius: "50%",
                                                          }}
                                                          src={`${SERVER_IP}/icons/${element.from_icon}`}
                                                          alt="img"
                                                        />
                                                      </div>
                                                      <i
                                                        className="fa-solid fa-check-double"
                                                        style={{
                                                          marginBottom: "5px",
                                                          marginLeft: "10px",
                                                          color: "green",
                                                        }}
                                                      ></i>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            ) : (
                                              <div
                                                className="outgoing_msg"
                                                key={index}
                                              >
                                                <div
                                                  className="sent_msg"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "flex-end",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "flex-end",
                                                    }}
                                                  >
                                                    <span className="name">
                                                      {element.from_name}
                                                    </span>
                                                    <span className="date">
                                                      {
                                                        element.datetime?.split(
                                                          " "
                                                        )[0]
                                                      }
                                                    </span>
                                                    <p>{element.message}</p>
                                                    <span className="time">
                                                      {
                                                        element.datetime?.split(
                                                          " "
                                                        )[1]
                                                      }{" "}
                                                      {
                                                        element.datetime?.split(
                                                          " "
                                                        )[2]
                                                      }
                                                    </span>
                                                  </div>
                                                  <div
                                                    style={{
                                                      width: "30px",
                                                      height: "96px",
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      justifyContent:
                                                        "space-between",
                                                      alignItems: "flex-end",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    <div className="incoming_msg_img">
                                                      <img
                                                        style={{
                                                          borderRadius: "50%",
                                                        }}
                                                        src={`${SERVER_IP}/icons/${element.from_icon}`}
                                                        alt="img"
                                                      />
                                                    </div>
                                                    <i
                                                      className="fa-solid fa-check-double"
                                                      style={{
                                                        marginBottom: "5px",
                                                        marginLeft: "10px",
                                                        color: "green",
                                                      }}
                                                    ></i>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          ) : // Incoming
                                          element.nonremovable == true ? (
                                            // Invite, Joined And Left Message
                                            <div
                                              className="outgoing_msg"
                                              key={index}
                                            >
                                              <div
                                                className="sent_msg"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      backgroundColor:
                                                        "rgb(194, 194, 194, 1)",
                                                    }}
                                                  >
                                                    {element.message}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          ) : element.message_type == "IMAGE" ||
                                            element.message_type == "VIDEO" ||
                                            element.message_type == "AUDIO" ||
                                            element.message_type == "FILE" ? (
                                            <div
                                              className="incoming_msg"
                                              style={{
                                                display: "flex",
                                                justifyContent: "flex-start",
                                              }}
                                              key={index}
                                            >
                                              {element.file
                                                ?.split(
                                                  "https://milan1.azurewebsites.net/"
                                                )[1]
                                                ?.split(".")[1] == "png" ||
                                              element.file
                                                ?.split(
                                                  "https://milan1.azurewebsites.net/"
                                                )[1]
                                                ?.split(".")[1] == "jpg" ? (
                                                <>
                                                  <div className="incoming_msg_img">
                                                    <img
                                                      style={{
                                                        borderRadius: "50%",
                                                      }}
                                                      src={`${SERVER_IP}/icons/${element.from_icon}`}
                                                      alt="img"
                                                    />
                                                  </div>
                                                  <div className="received_msg">
                                                    <div
                                                      className="received_withd_msg"
                                                      style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                      }}
                                                    >
                                                      <span className="name">
                                                        {element.from_name}
                                                      </span>
                                                      <span className="date">
                                                        {
                                                          element.datetime?.split(
                                                            " "
                                                          )[0]
                                                        }
                                                      </span>
                                                      <div className="received_file_msg">
                                                        <div className="received_file_div">
                                                          <img
                                                            style={{
                                                              borderRadius: "50%",
                                                            }}
                                                            src={element.file}
                                                            alt="Uploaded Image"
                                                          />
                                                          <div className="received_file_txt">
                                                            <p>
                                                              {element.file_name}
                                                            </p>
                                                          </div>
                                                        </div>
                                                        <button
                                                          type="button"
                                                          className="btn btn-outline-secondary w-100"
                                                          onClick={() =>
                                                            downloadFile(
                                                              element.file,
                                                              element.file_name
                                                            )
                                                          }
                                                        >
                                                          <i className="fa-solid fa-download"></i>
                                                        </button>
                                                      </div>
                                                      <span className="time">
                                                        {
                                                          element.datetime?.split(
                                                            " "
                                                          )[1]
                                                        }{" "}
                                                        {
                                                          element.datetime?.split(
                                                            " "
                                                          )[2]
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <div
                                                    className="incoming_msg_img"
                                                    key={index}
                                                  >
                                                    <img
                                                      style={{
                                                        borderRadius: "50%",
                                                      }}
                                                      src={`${SERVER_IP}/icons/${element.from_icon}`}
                                                      alt="img"
                                                    />
                                                  </div>
                                                  <div className="received_msg">
                                                    <div
                                                      className="received_withd_msg"
                                                      style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                      }}
                                                    >
                                                      <span className="name">
                                                        {element.from_name}
                                                      </span>
                                                      <span className="date">
                                                        {
                                                          element.datetime?.split(
                                                            " "
                                                          )[0]
                                                        }
                                                      </span>
                                                      <div className="received_file_msg">
                                                        <div className="received_file_div">
                                                          <img
                                                            src="https://www.pngall.com/wp-content/uploads/2018/05/Files-High-Quality-PNG.png"
                                                            alt="Uploaded File"
                                                          />
                                                          <div className="received_file_txt">
                                                            <p>
                                                              {element.file_name}
                                                            </p>
                                                          </div>
                                                        </div>
                                                        <button
                                                          type="button"
                                                          className="btn btn-outline-secondary w-100"
                                                          onClick={() =>
                                                            downloadFile(
                                                              element.file,
                                                              element.file_name
                                                            )
                                                          }
                                                        >
                                                          <i className="fa-solid fa-download"></i>
                                                        </button>
                                                      </div>
                                                      <span className="time">
                                                        {
                                                          element.datetime?.split(
                                                            " "
                                                          )[1]
                                                        }{" "}
                                                        {
                                                          element.datetime?.split(
                                                            " "
                                                          )[2]
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          ) : (
                                            <div
                                              className="incoming_msg"
                                              key={index}
                                            >
                                              <div className="incoming_msg_img">
                                                <img
                                                  style={{ borderRadius: "50%" }}
                                                  src={`${SERVER_IP}/icons/${element.from_icon}`}
                                                  alt="img"
                                                />{" "}
                                              </div>
                                              <div className="received_msg">
                                                <div
                                                  className="received_withd_msg"
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "flex-start",
                                                  }}
                                                >
                                                  <span className="name">
                                                    {element.from_name}
                                                  </span>
                                                  <span className="date">
                                                    {
                                                      element.datetime?.split(
                                                        " "
                                                      )[0]
                                                    }
                                                  </span>
                                                  <p>{element.message}</p>
                                                  <span className="time">
                                                    {
                                                      element.datetime?.split(
                                                        " "
                                                      )[1]
                                                    }{" "}
                                                    {
                                                      element.datetime?.split(
                                                        " "
                                                      )[2]
                                                    }
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                    </>
                                  )
                                })}
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      )
                    })}
                  </Container>
                </InfiniteScroll>
              </div>
              :
              <>
                <p className="p-3">No record Found </p>
              </>
              }

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
